<template>
  <v-card>
    <v-layout>
      
      <v-app-bar
        color="primary"
        prominent
      >
        <router-link to="/" class="d-flex align-center">    
        
          <img v-if="nombre_app === 'ralph'"
            :src="require('../assets/ralph.svg')"
            alt="Logo" 
            style="height: 40px; cursor: pointer; margin: 0 20px;"  
          />

          <img v-if="nombre_app === 'ophelia'"
            :src="require('../assets/ophelia.svg')"
            alt="Logo" 
            style="height: 40px; cursor: pointer; margin: 0 20px;"  
          />          
        
        </router-link>

        <v-toolbar-title class="text-subtitle-2">{{$t('login.titulo')}}</v-toolbar-title>

        <v-spacer></v-spacer>


        <v-btn icon @click="dialog = true">
          <v-icon>mdi-book-open-variant</v-icon>
        </v-btn>

        <v-dialog v-model="dialog" max-width="1200">
          <v-card>
            <v-card-title>Manual de usuario</v-card-title>
            <v-card-text>              
                  <ComponenteDoc/>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="dialog = false">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>        

        <template v-if="$vuetify.display.mdAndUp">
          {{ usuario }}
        </template>


      <!-- Contenedor para idioma e ícono de salida -->
        <div class="d-flex align-center">
          <!-- Selector de idioma -->
          <ComponenteIdioma class="mr-3" />

          <!-- Icono de salir -->
          <router-link to="/login" class="nav-link">
            <v-btn icon="mdi-exit-to-app" variant="text"></v-btn>
          </router-link>
        </div>


      </v-app-bar>


      <!--<v-main style="height: 1600px;">-->

        <v-main>


        <router-view></router-view>

        <!--
        <div v-if="isRouterViewEmpty">
          <br><br><br>          
          <img :src="require('../assets/rednet1.png')" alt="Empty State" class="empty-state-image" style="opacity: 0.1;"/>
        </div>
        -->


      </v-main>

    </v-layout>
  </v-card>
</template>
<script>
  import store from '../store';
  import ComponenteIdioma from './ComponenteIdioma.vue';
  import ComponenteDoc from './ComponenteDoc.vue';
  export default {
    data: () => ({
      dialog: false,
      usuario: store.state.usuarioNombre,
      nombre_app: "",
      drawer: false,
      group: null,
      items: [
        {
          title: 'Foo',
          value: 'foo',
        },
        {
          title: 'Bar',
          value: 'bar',
        },
        {
          title: 'Fizz',
          value: 'fizz',
        },
        {
          title: 'Buzz',
          value: 'buzz',
        },
      ],
    }),

    components: {
      ComponenteIdioma,
      ComponenteDoc,
    },


    watch: {
      group () {
        this.drawer = false
      },
    },


    mounted(){
      //alert(JSON.stringify(store.state))
    },

    
    created() {
        // Cargar configuración proporcionada desde `main.js`
        fetch('/config.json')
          .then((response) => response.json())
          .then((config) => {
            this.nombre_app = config.nombre_app;  
                     
          })
          .catch((error) => {
            console.error('Error al cargar la configuración:', error);
            
          });
      },    
    

    computed: {
    isRouterViewEmpty() {
      // Determina si el router-view está vacío

      console.log("nombre:")
      console.log(this.$route.name)
      console.log(!this.$route.name)

      if (this.$route.name == 'PaginaHome') {
          return true
      } else {
          return false
      }

      
      }
    }


  }
</script>


<style scoped>
.nav-link {
  text-decoration: none;
  color: inherit; /* Heredar el color del texto padre */
  display: flex;
  align-items: center; /* Alinear ícono y texto verticalmente */
}

.nav-icon {
  margin-right: 8px; /* Espacio entre el ícono y el texto */
}

.empty-state {
  justify-content: center;
  align-items: center;
}

.empty-state-image {
  /* Estilos para tu imagen */
  width: 800px;
  height: auto;
  display: block;
  max-width: 800px; /* Ajusta este valor según sea necesario */
  margin: 0 auto;
}





</style>